import { SET_META_DATA } from "../acions/types";

const initialState = {};

export default function metaData(state = initialState, action: any) {
  const { type, payload } = action;

  switch (type) {
    case SET_META_DATA:
      return { ...payload };
    default:
      return state;
  }
}
